<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab icon-pack="iconfont" icon="icon-user" :label="!isSmallerScreen ? '个人资料' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-general />
      </div>
    </vs-tab>
    <vs-tab icon-pack="iconfont" icon="icon-eye" :label="!isSmallerScreen ? '修改密码' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-change-password />
      </div>
    </vs-tab>
    <vs-tab icon-pack="iconfont" icon="icon-container" :label="!isSmallerScreen ? '公司信息' : ''" v-if="$acl.check('self_company')">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <company />
      </div>
    </vs-tab>
    <vs-tab icon-pack="iconfont" icon="icon-phone" :label="!isSmallerScreen ? '联系人信息' : ''" v-if="$acl.check('self_contact') && !$acl.check('admin')">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <contact />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import UserSettingsGeneral from "./general.vue"
import UserSettingsChangePassword from "./change_password.vue"
import Company from './company'
import Contact from './contact'
// import UserSettingsConnections from "./connections.vue"

export default {
  components: {
    UserSettingsGeneral,
    UserSettingsChangePassword,
    Company,
    Contact,
    // UserSettingsConnections,
  },
  data() {
    return {

    }
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
